import { absolutePath } from "./absolutePath";

const BASE_PATH = "connect/connections";

export const connections = {
  create: () => absolutePath(`${BASE_PATH}`),
  accept: (id: string) => absolutePath(`${BASE_PATH}/${id}/accept`),
  ignore: (id: string) => absolutePath(`${BASE_PATH}/${id}/ignore`),
  withdraw: (id: string) => absolutePath(`${BASE_PATH}/${id}/withdraw`),
};
